// extracted by mini-css-extract-plugin
export default {"grid_4":"styles_grid_4__s8ZFZ","grid_5":"styles_grid_5__bs2WM"};